import React from 'react'
import SimpleModal from 'components/SimpleModal'
import { Col, Row } from 'reactstrap'
import { CustomButton } from 'styles/global'
import { ModalIndicacaoWrapper, CloseIconRed } from 'views/simulacao/style'
import { MetodosFgts } from 'store/modules/simulacao/types'
import useRedux from 'hooks/useRedux'
import * as simulacaoActions from 'store/modules/simulacao/actions'

interface Indicacao {
  isOpen: boolean
  toggle: () => void
  metodo: MetodosFgts | null
}

const Indicacao6 = ({ isOpen, toggle, metodo }: Indicacao) => {
  const { dispatch } = useRedux()
  function onToggle() {
    if (metodo === MetodosFgts.SolicitarSimulacao) {
      dispatch(simulacaoActions.getParcelasFgtsSaga())
    }
    toggle()
  }
  return (
    <SimpleModal toggle={onToggle} isOpen={isOpen} size="sm">
      <ModalIndicacaoWrapper>
        <div className="container-fluid d-flex flex-column row-gap-15 position-relative">
          {/* Botão de fechar estilizado */}
          <button
            onClick={onToggle}
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              background: 'none',
              border: 'none',
              fontSize: '20px',
              cursor: 'pointer',
              color: 'gray'
            }}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div className="container-fluid d-flex flex-column row-gap-15">
          <div className="d-flex justify-content-center">
            <CloseIconRed />
          </div>
          <h3 className="main-title">Ops... Algo deu errado</h3>
          <p className="text-center common-text">
            Mudanças cadastrais na conta do FGTS foram realizadas, que impedem a
            contratação. Entre em contato com o setor de FGTS da Caixa.
          </p>
          <Row>
            <Col className="d-flex align-items-center justify-content-center">
              <CustomButton
                background="var(--roxo-riber)"
                onClick={() => {
                  toggle()
                }}
              >
                ENTENDI
              </CustomButton>
            </Col>
          </Row>
        </div>
      </ModalIndicacaoWrapper>
    </SimpleModal>
  )
}

export default Indicacao6
